import React from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { Link } from "react-router-dom";
import { ModalDialog } from "../../../components/SkyFramework/Dialog/ModalDialog";
import { ModalButton } from '../../../components/SkyFramework/Modal'
import { trueOrFalse } from '../../../helpers/util';

const checkConditions = (conditions, row) => {
  var result = true;
  conditions.forEach(condition => {
    switch (condition[1]) {
      case 'eq':
        if (condition[0] !== row[condition[2]]) result = false;
        break;
      case 'neq':
        if (condition[0] === row[condition[2]]) result = false;
        break;
      case 'lt':
        if (condition[0] >= row[condition[2]]) result = false;
        break;
      case 'leqt':
        if (condition[0] > row[condition[2]]) result = false;
        break;
      case 'gt':
        if (condition[0] <= row[condition[2]]) result = false;
        break;
      case 'geqt':
        if (condition[0] < row[condition[2]]) result = false;
        break;
      case 'inc':
        if (!condition[0].includes(row[condition[2]])) result = false;
        break;
      case 'ninc':
        if (condition[0].includes(row[condition[2]])) result = false;
        break;
      default:
        result = false;
        break;
    }
    // if (result == false) return result;
  })
  return result;

}


const CheckActions = (props) => {
  if (props.actions)
    return (
      <td>
        <div className="dropdown">
          <button className="btn" data-toggle="dropdown">
            <i className="sky-icon-menu"></i>
          </button>
          <ul className="dropdown-menu dropdown-right">
            {props.actions.map((action, index) => {
              if (!action.condition || (action.condition && checkConditions(action.condition, props.row))) {
                if (action.type === "link") {
                  action["action_key"] = props.action_key;
                  const newLocation = action.location.replace(
                    `:${props.action_key}`,
                    props.row[props.action_key]
                  );
                  return GoToLink(
                    newLocation,
                    action.onClick,
                    action.label,
                    props.row[props.action_key]
                  );
                }

                if (action.type === "action") {
                  action["action_key"] = props.action_key;
                  return ActionLink(
                    action.onClick,
                    action.label,
                    props.row[props.action_key]
                  );
                }
                if (action.type === "form") {
                  action["action_key"] = props.action_key;
                  return ContinueLink(
                    action.onClick,
                    action.label,
                    props.index
                  );
                }
                if (action.type === "modal") {
                  return ModalInfo(action.label, props.row[props.action_key])
                }
              }
            })}
          </ul>
        </div>
      </td>
    );
  else return null;
};

const ActionLink = (onClick = () => null, label = "", action_key = "") => (
  <li>
    <a href="#" id={action_key} onClick={onClick}>
      {label}
    </a>
  </li>
);

const GoToLink = (
  location = "",
  onClick = () => null,
  label = "",
  action_key = ""
) => (
  <li>
    <Link to={location} onClick={onClick(action_key)}>
      {label}
    </Link>
  </li>
);

const ContinueLink = (onClick = () => null, label = "", value = "") => (
  <li>
    {" "}
    <button className="btn btn-simple" value={value} onClick={onClick}>
      {label}
    </button>
  </li>
);

const ModalInfo = (label = "", id) => (
  <>
    <li>
      <ModalButton label={label} className={"btn btn-simple"} href={"#modal_" + id} />
    </li>
  </>
)

function NestedItem({ field, row, index }) {
  if (Array.isArray(field) && row[field[0]]) {
    if (field.length === 2) {
      if (typeof row[field[0]][field[1]] === "boolean")
        return <td>{trueOrFalse(row[field[0]][field[1]])}</td>;
      else if (Array.isArray(field[1])) {
        console.log(Array.isArray(field[1]));
        console.log(field);
        return <td>{row[field[0]].map(e => e[field[1][0]]).join(",")}</td>;
      }
      else return <td>{row[field[0]][field[1]]}</td>;

    } else if (field.length === 3) {
      if (typeof row[field[0]][field[1]][field[2]] === "boolean")
        return <td>{trueOrFalse(row[field[0]][field[1]][field[2]])}</td>;
      else return <td>{row[field[0]][field[1]][field[2]]}</td>;
    }
  } else if (field === 'option_generator') {
    return <td>Option {index + 1}</td>;

  } else {
    if (typeof row[field] === "boolean")
      return <td>{trueOrFalse(row[field])}</td>;
    else if (Array.isArray(row[field]))
      return <td>{row[field].join(", ")}</td>;
    else return <td>{row[field]}</td>;
  }
}


export const TableRow = (props) => {
  return (
    <tr>
      {/* <td className="checkbox" >
      <label className="custom-checkbox no-label">
        <input type="checkbox" value="checkbox1b" />
        <span></span>
      </label>
    </td> */}
      {props.keys.map((key) => (
        <NestedItem field={key} row={props.row} index={props.index} />
      ))}
      <CheckActions {...props} />
    </tr>
  );
};
